import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import './styles.css';
import DefaultTextBold from '../../../../components/Accessibility/DefaultTextBold';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';

interface AddShortcutCardProps {
	onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
	onFocus: () => void;
	onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void;
}

const AddShortcutCard: React.FC<AddShortcutCardProps> = ({ onClick, onFocus, onKeyDown }) => {
	const { contrastStyle, contrastBorderAccessibility, contrastColorAccessibility } = useAccessibility()
	return (
		<div
			className="card-add-atalho"
			style={{ ...contrastStyle, ...contrastBorderAccessibility }}
			tabIndex={0}
			onClick={onClick}
			onFocus={onFocus}
			onKeyDown={onKeyDown}
		>
			<FontAwesomeIcon icon={faPlus} className="fa-icon32x32" style={{ ...contrastColorAccessibility }} />
			<DefaultTextBold text="Adicionar atalho" className="card-add-atalho-title" />
		</div>
	);
};

export default AddShortcutCard;
